import { GetStaticPropsContext } from "next";
import type { Menu } from "@lib/menu";
import { MenuStructDTO } from "@lib/strapi/dtos/content-types/menuStruct.dto";
import { MenuStructService } from "@lib/strapi/services/content-types/menuStruct.service";

/**
 * Maps seeded CMS menu-structs (menu-header/menu-item components) onto the
 * frontend Menu model (see the StrapiMenus registry for the seeded slugs).
 */
export const toMenu = (dto: MenuStructDTO | null): Menu | null => {
  if (!dto?.menuItems?.length) {
    return null;
  }
  return {
    items: dto.menuItems.map((header) => ({
      text: header.link?.title ?? "",
      url: header.link?.url,
      subMenu: header.menuItems?.length
        ? {
            items: header.menuItems.map((item) => ({
              text: item.link?.title ?? "",
              url: item.link?.url,
            })),
          }
        : undefined,
    })),
  };
};

export const fetchMenu = async (
  context: GetStaticPropsContext,
  slug: string
): Promise<Menu | null> => {
  try {
    const dto = await MenuStructService.fetchBySlug(
      undefined,
      context.locale,
      slug
    );
    return toMenu(dto);
  } catch {
    // menus fall back to the locale-file defaults at the call sites
    return null;
  }
};
